// Normaliza a lista de UFs (array ou string, com espaços extras) para ['AC', 'AL', 'MG']
export function parseUFs(value) {
  if (!value) return []
  const list = Array.isArray(value) ? value : [value]
  return list
    .flatMap(item => String(item).split(/[\s,;]+/))
    .map(uf => uf.trim().toUpperCase())
    .filter(Boolean)
}

export function getUserUF(user) {
  return user?.address?.[0]?.state?.toString().trim().toUpperCase()
}

export function isUFDenied(uf, deniedList) {
  return parseUFs(deniedList).includes(uf)
}
